import { apiStatic, requestError } from 'AurionCR/components';
import { parseMixins, saveMixins } from 'AurionCR/components/formV2';
import { notifyRequestResult } from 'AurionCR/store/modules/notify';
import { prepareRequest, queryEncoderObject } from 'components/helpers';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  API_RATING_PROCESS_STEP_COMMITTEE_SIGNIFICANT_CHANGE,
  tRatingProcessStepCommitteeSignificantChange,
} from 'services/rating-process-step-committee-significant-change';
import {
  iRPState,
  iRPStepType3ActionTypes,
  iRPStepType3SCInitAction,
  iRPStepType3SCSaveItemAction,
} from '../../@type';
import {
  iRPStepType3SCMerge,
  iRPStepType3SCMergeItem,
  iRPStepType3SCMergeItemData,
} from '../../helpers';

const getData = (id: number) => {
  return apiStatic.post(
    API_RATING_PROCESS_STEP_COMMITTEE_SIGNIFICANT_CHANGE.GET_ALL_DYNAMIC,
    queryEncoderObject({
      filter: `ratingProcessStepCommitteeID==${id}`,
      select: [
        'id',
        'title',
        'ratingProcessStepCommitteeID',
        'committeeSignificantChangeTypeID',
        'remarks',
        'isActive',
      ].join(),
    }),
  );
};

function* init({ payload: { committeeIndex } }: iRPStepType3SCInitAction) {
  const {
    stepType3: {
      list: {
        [committeeIndex]: {
          id,
          significantChange: { isInit, isLoading },
        },
      },
    },
  }: iRPState = yield select((state) => state.RP);
  if (!isInit && !isLoading) {
    yield put(iRPStepType3SCMerge({ committeeIndex, isLoading: true }));
    try {
      const {
        data: { value },
      }: { data: { value: tRatingProcessStepCommitteeSignificantChange[] } } = yield call(
        getData,
        id,
      );
      // set data
      yield put(
        iRPStepType3SCMerge({
          committeeIndex,
          isLoading: false,
          isInit: true,
          list: value.map((item, index) => ({
            index,
            isLoading: false,
            data: item,
          })),
        }),
      );
    } catch (e) {
      yield put(iRPStepType3SCMerge({ committeeIndex, isLoading: false }));
      yield put(notifyRequestResult(requestError(e), 'error'));
    }
  }
}

function* saveItem({
  payload: { committeeIndex, itemIndex, ...newData },
}: iRPStepType3SCSaveItemAction) {
  const {
    stepType3: {
      list: {
        [committeeIndex]: {
          significantChange: {
            list: {
              [itemIndex]: { data: prevData },
            },
          },
        },
      },
    },
  }: iRPState = yield select((state) => state.RP);
  yield put(iRPStepType3SCMergeItem({ committeeIndex, itemIndex, isLoading: true }));
  try {
    let { data, mixins } = parseMixins(newData);
    // @ts-ignore
    data = yield call(saveMixins, data, mixins);
    yield call(
      apiStatic.patch,
      API_RATING_PROCESS_STEP_COMMITTEE_SIGNIFICANT_CHANGE.PATCH(prevData),
      prepareRequest(data),
    );
    yield put(iRPStepType3SCMergeItemData({ committeeIndex, itemIndex, ...data }));
  } catch (e) {
    yield put(iRPStepType3SCMergeItemData({ committeeIndex, itemIndex, ...prevData }));
    yield put(notifyRequestResult(requestError(e), 'error'));
  }
  yield put(iRPStepType3SCMergeItem({ committeeIndex, itemIndex, isLoading: false }));
}

export const SC = [
  takeLatest(iRPStepType3ActionTypes.RP_STEP_TYPE_3_SC_INIT, init),
  takeEvery(iRPStepType3ActionTypes.RP_STEP_TYPE_3_SC_SAVE_ITEM, saveItem),
];
